/**
 * @description 判斷會員帳號(身份證號)第 2 碼性別、國籍用
*/
export enum IdInfoType {
  /** 本國人-男性 */
  NationalMale = '1',
  /** 居留證-男性(新式) */
  ForeignMale = '8',
  /** 居留證-無國籍男性 */
  ResidentStatelessMale = 'A',
  /** 居留證-男性 */
  ResidentMale = 'C',

  /** 本國人-女性 */
  NationalFemale = '2',
  /** 居留證-女性(新式) */
  ForeignFemale = '9',
  /** 居留證-無國籍女性 */
  ResidentStatelessFemale = 'B',
  /** 居留證-女性 */
  ResidentFemale = 'D'
}
